export default {
  computed: {
    personalData() {
      return this.checkout.personalData;
    },
    fullName() {
      return `${this.personalData.first_name} ${this.personalData.last_name}`;
    },
    shippingAddressFullName() {
      return `${this.personalData.shipping_first_name} ${this.personalData.shipping_last_name}`;
    },
    customerDetails() {
      return {
        fullName: this.personalData.shipping_address
          ? this.shippingAddressFullName : this.fullName,
        address: this.personalData.shipping_address
          ? this.personalData.shipping_address_street
          : this.personalData.street,
        zip: this.personalData.shipping_address
          ? this.personalData.shipping_address_zip : this.personalData.zip,
        city: this.personalData.shipping_address
          ? this.personalData.shipping_address_city : this.personalData.city,
        country: this._.find(this.countryOptions, {
          id: this.personalData.shipping_address
            ? this.personalData.shipping_address_country
            : this.personalData.country_id,
        }).name,
      };
    },
  },
  methods: {
    async selectShippingOption(index) {
      const loader = this.$loading.show();

      if (!this.checkout.paymentOption) {
        await this.$store.dispatch('INIT_PAYMENT_OPTIONS');
      }

      const form = {};
      const checkout = this.checkout;

      checkout.shippingOption = this.shippingOptions[index];
      checkout.paymentOption = null;

      if (checkout.shippingOption) {
        if (checkout.shippingOption.shippingRateId) {
          form.shop_shipping_rate_id = checkout.shippingOption.shippingRateId;
        }

        if (checkout.shippingOption.shippingOptionId === 4) {
          form.shop_individual_shipping_option_id = checkout.shippingOption.id;
        } else {
          form.shop_shipping_option_id = checkout.shippingOption.id;
        }
      }

      try {
      await this.axios.put(
          `v2/temp-order/${this.checkout.authType}/${this.tmpOrder.id}`, {form});

        this.$store.dispatch('SET_CHECKOUT', checkout);

        if (this.checkout.paymentOption) {
          this.$store.dispatch('SET_CHECKOUT_STEP', 6);
        } else {
          const nextStep = this.$store.getters.COUPONS_ENABLED ? 1 : 2;
          this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep + nextStep);
        }

        loader.hide();
      } catch (e) {
        loader.hide();
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
  },
  created() {
    this.$emit('info', this.$t('shipping'));
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
};
